import React, { useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";

import Layout from '../../components/Layout/Admin'
import { Container, Form, ButtonArea } from './styles';

import { useAlert } from 'react-alert'

import api from "../../services/api";
import { login } from "../../services/auth";

import { FormInput, FormButton, FormLabel } from '../../components/Form/Input'

function Login(props) {
  const alert = useAlert()
  
  const [ user, setUser ] = useState({ email: "", password: "" })

  async function handleLogin(e){
    e.preventDefault()
    const { email, password } = user

    if (!email || !password) {
      alert.error("Provide email and password to continue")
    } else {
      try {
        const response = await api.post("/users/login", { email, password })
        login(response.data.token)
        props.history.push("/admin");
      } catch (err) {
        alert.error("Unable to login. Verify your credentials")
      }
    }
  }

  return (
    <Layout selected="challenges">
      <Container>
        <Form onSubmit={ (e) => handleLogin(e) }>
          <FormInput
            type="email"
            placeholder="Email"
            onChange={e => setUser({ email: e.target.value, password: user.password })}
          />
          <FormInput
            type="password"
            placeholder="Password"
            onChange={e => setUser({ email: user.email, password: e.target.value })}
          />
          <ButtonArea>
            <FormButton type="submit">Login</FormButton>
          </ButtonArea>
        </Form>
      </Container>
    </Layout>
  )
}

export default withRouter(Login)
